var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_lio",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M11.094,14.554H7.176s-2.217,0-2.217,0a2.327,2.327,0,0,1,2.217-2.33.642.642,0,0,1,.092,0h.024s3.8,0,3.8,0a1.128,1.128,0,0,0,1.127-1.127V7.286a.164.164,0,0,1,0-.024V7.171A2.336,2.336,0,0,1,12.9,5.635a2.313,2.313,0,0,1,1.651-.681l0,2.217s0,3.924,0,3.924A3.464,3.464,0,0,1,11.094,14.554Zm9.716-1.105s-3.9,0-3.9,0a3.464,3.464,0,0,0-3.46,3.46v3.909s0,2.217,0,2.217a2.327,2.327,0,0,0,2.33-2.217.645.645,0,0,0,0-.095c0-.007,0-.014,0-.021s0-3.793,0-3.793a1.128,1.128,0,0,1,1.127-1.127h3.9a2.337,2.337,0,0,0,1.535-.684,2.313,2.313,0,0,0,.681-1.651ZM28,14A14,14,0,1,1,14,0,14.016,14.016,0,0,1,28,14Zm-2.333,0A11.667,11.667,0,1,0,14,25.667,11.68,11.68,0,0,0,25.667,14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLio);
export default __webpack_public_path__ + "static/media/ico-lio.3e38579ce2fd616e3c687282dbc04946.svg";
export { ForwardRef as ReactComponent };